// src/pages/Inventory/InventoryDashboard.jsx
import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import {
  AppstoreOutlined,
  DatabaseOutlined,
  BarChartOutlined,
  RetweetOutlined,
  FolderOutlined,
  FileSearchOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./inventoryDashboard.css";
import { accessChecker } from "../lib/functions";

const { Title } = Typography;

const InventoryDashboard = () => {
  const navigate = useNavigate();

  const shortcuts = [
    {
      key: "item_entry",
      label: "Items",
      path: "/inventory/product",
      value: "item_entry",
      icon: <DatabaseOutlined />,
    },
    {
      key: "item_stock_report",
      label: "Item Stock Report",
      value: "item_stock_report",
      path: "/inventory/item-stock-report",
      icon: <FileSearchOutlined />,
    },

    {
      key: "item_ledger",
      label: "Item Ledger",
      value: "item_ledger",
      path: "/inventory/item-ledger",
      icon: <FileSearchOutlined />,
    },
    {
      key: "item_adjustment_entry",
      label: "Item Adjustment",
      value: "item_adjustment_entry",
      path: "/inventory/item-adjustment",
      icon: <BarChartOutlined />,
    },
    {
      key: "item_category",
      label: "Category",
      value: "item_category",
      path: "/inventory/category",
      icon: <FolderOutlined />,
    },
    {
      key: "group_entry",
      label: "Group Entry",
      value: "group_entry",
      path: "/inventory/item-group-entry",
      icon: <FolderOutlined />,
    },
    {
      key: "item_unit",
      label: "Unit Entry",
      value: "item_unit",
      path: "/inventory/unit-manage",
      icon: <AppstoreOutlined />,
    },
    {
      key: "model_manage",
      label: "Models",
      value: "model_manage",
      path: "/inventory/models-manage",
      icon: <AppstoreOutlined />,
    },
    {
      key: "origin_manage",
      label: "Origins",
      value: "origin_manage",
      path: "/inventory/origins-manage",
      icon: <AppstoreOutlined />,
    },
    {
      key: "rack_manage",
      label: "Racks",
      value: "rack_manage",
      path: "/inventory/racks-manage",
      icon: <AppstoreOutlined />,
    },
    {
      key: "transfer_entry",
      label: "Transfer Entry",
      value: "transfer_entry",
      path: "/inventory/transfer-entry",
      icon: <RetweetOutlined />,
    },
    {
      key: "transfer_pending_record",
      label: "Transfer Pending Record",
      value: "transfer_pending_record",
      path: "/inventory/transfer-pending-record",
      icon: <InboxOutlined />,
    },
    {
      key: "transfer_receive_record",
      label: "Transfer Received Record",
      value: "transfer_receive_record",
      path: "/inventory/transfer-receive-record",
      icon: <InboxOutlined />,
    },
    {
      key: "transfer_record",
      label: "Transfer Record",
      value: "transfer_record",
      path: "/inventory/transfer-record",
      icon: <InboxOutlined />,
    },
    {
      key: "adjustment_record",
      label: "Adjustment Record",
      value: "adjustment_record",
      path: "/inventory/adjustment-record",
      icon: <InboxOutlined />,
    },

    {
      key: "tatmeen_entry",
      label: "Heirrachy Flow",
      value: "tatmeen_entry",
      path: "/inventory/heirrachy-flow",
      icon: <InboxOutlined />,
    },

  ];

  const filteredMenuData = shortcuts.filter((menuItem) =>
    accessChecker(menuItem.value)
  );

  return (
    <div style={{ padding: "24px" }}>
      <Title level={3} style={{ marginBottom: 24 }}>
        Inventory Dashboard
      </Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData?.map((item, idx) => (
          <Col xs={24} sm={12} md={8} lg={6} key={idx}>
            <Card
              hoverable
              style={{
                textAlign: "center",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
              onClick={() => navigate(item.path)}
            >
              <div style={{ fontSize: 28, marginBottom: 12 }}>
                {item.icon}
              </div>
              <Button type="link">{item.label}</Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default InventoryDashboard;
